export const DEFAULT = 'DEFAULT';
export const PROGRESSIVE = 'PROGRESSIVE';
